<template>
    <component :is="layout"></component>
</template>

<script>
import Default from './layouts/Default/index.vue';
import Empty from './layouts/Empty/index.vue';

export default {
  name: 'AppWrapper',
  components: {
    default: Default,
    empty: Empty,
  },
  computed: {
    layout () {
      return this.$store.getters.layout;
    },
  },
  created() {
    this.$store.dispatch('LAZY_GET_DICTONARIES');
  },
};
</script>

<style lang="css" src="@/style/multiselect.min.css"></style>
<style lang="css" src="@/style/table-reset.css"></style>
<style lang="scss" src="@/style/app.scss"></style>
